

















































































































































































































































import { Component, Vue, Emit, Prop, Ref } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { maskMoney, maskCPFCNPJ, maskDateTime } from '@/utils/common'
import EventBus from '@/plugins/EventBus'

@Component

export default class ComponentModalMultiplasNotasFiscais extends Vue {
  @Prop({ required: true, default: false }) disabled: boolean

  loadEditar = ''
  modalDeleteNotaFiscal = false
  loadingDownloadNf: any = null
  loadingDeletarDocumento: any = null
  loadingUploadDocumento: boolean = false

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get headers() {
    return [
      { text: 'Nome do arquivo', value: 'nomeArquivoOriginal', align: 'center' },
      { text: 'Data recebimento', value: 'dataRecebimentoNota', align: 'center' },
      { text: 'Número da nota', value: 'numeroNota', align: 'center' },
      { text: 'Valor da nota', value: 'valorNotaFiscal', align: 'center' },
      { text: 'Situação', value: 'situacao', align: 'center' },
      { text: 'Criado por', value: 'createdByNome', align: 'center' },
      { text: 'Data criação', value: 'createdOn', align: 'center' },
      { text: 'Ações', value: 'actions', sortable: false, align: 'center' },
    ]
  }

  get loadingEditar() {
    return this.loadEditar
  }

  set loadingEditar(value: string) {
    this.loadEditar = value
  }

  get showModalDeleteNotaFiscal() {
    return this.modalDeleteNotaFiscal
  }

  set showModalDeleteNotaFiscal(value: boolean) {
    this.modalDeleteNotaFiscal = value
  }

  get showModalAtualizarNotaFiscal() {
    return this.getFinanceiroStore.modal.multiplasNotasFiscais
  }

  get prestadorRecebimento() {
    return this.getFinanceiroStore.prestadorRecebimento
  }

  get documentosAdicionais() {
    return Array.isArray(this.prestadorRecebimento.documentosAdicionais) ? this.prestadorRecebimento.documentosAdicionais : []
  }

  get acoesRecebimento() {
    return this.getFinanceiroStore.acoesItemRecebimento
  }

  get permiteDocumentosAdicionais() {
    return this.acoesRecebimento ? this.acoesRecebimento.habilitaDocumentoAdicional : false
  }

  get documentoAdicionalObrigatorio() {
    return this.acoesRecebimento ? this.acoesRecebimento.documentoAdicionalObrigatorio : false
  }

  get minimoDocumentosAdicionais() {
    return this.acoesRecebimento ? this.acoesRecebimento.minimoDocumentoAdicional : 0
  }

  get maximoDocumentosAdicionais() {
    return this.acoesRecebimento ? this.acoesRecebimento.maximoDocumentoAdicional : 10
  }

  get totalDocumentosAdicionais() {
    return this.documentosAdicionais.length
  }

  get atingiuMaximoDocumentosAdicionais() {
    return this.totalDocumentosAdicionais >= this.maximoDocumentosAdicionais
  }

  formatMoneyUtil(money: any) {
    return maskMoney(money)
  }

  formatDateTimeUtil(date: string) {
    return maskDateTime(date)
  }

  maskCPFCNPJUtil(value: string) {
    return maskCPFCNPJ(value)
  }

  closeModal() {
    this.getFinanceiroStore.setModal({ name: 'multiplasNotasFiscais', value: false })
  }

  openModalDeleteNotaFiscal(id: string) {
    this.getFinanceiroStore.setIdForDeleteNotaFiscal(id)
    this.showModalDeleteNotaFiscal = true
  }

  async deleteNotaFiscal() {
    const response = await this.getFinanceiroStore.deleteNotaFiscal()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Nota fiscal excluída com sucesso!', icon: 'done', color: '#2E7D32' })
      this.getFinanceiroStore.geRecebimentoById(this.getFinanceiroStore.prestadorRecebimento.id)
      this.showModalDeleteNotaFiscal = false
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Ocorreu um erro ao excluir a nota fiscal.', icon: 'warning', color: '#C62828' })
    }
  }

  async editar(item: any) {
    this.loadingEditar = item.id
    if (item.nomeArquivoOriginal) {
      this.getFinanceiroStore.setDisabledConfirmar(true)
    }
    this.getFinanceiroStore.setIsNewNotaFiscal(true)
    this.getFinanceiroStore.setNotaFiscalItem(item)

    this.getFinanceiroStore.setDocumentoId(item.documentoId)
    this.getFinanceiroStore.setModal({ name: 'editarNotaFiscal', value: true })
    this.loadingEditar = ''
  }

  novaNotaFiscal() {
    this.getFinanceiroStore.setModal({ name: 'editarNotaFiscal', value: true })
  }

  async inputFile(newFile: any) {
    if (!newFile || newFile.identifier) {
      return
    }

    const { file } = newFile
    const isValidPDF = file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')

    if (!isValidPDF) {
      EventBus.$emit('setSnackbar', { show: true, text: 'O arquivo enviado não possui formato válido. Apenas PDF é permitido.', icon: 'warning', color: '#C62828' })
      return
    }

    this.loadingUploadDocumento = true

    const formData = new FormData()
    formData.append('files', file)

    const response = await this.getFinanceiroStore.uploadDocumentosAdicionais({
      prestadorRecebimentoId: this.prestadorRecebimento.id,
      formData,
    })

    if (response.success) {
      await this.getFinanceiroStore.geRecebimentoById(this.prestadorRecebimento.id)
      EventBus.$emit('setSnackbar', { show: true, text: 'Documento adicional enviado com sucesso.', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema ao enviar o documento adicional.', icon: 'warning', color: '#C62828' })
    }

    this.loadingUploadDocumento = false
  }

  async deletarDocumento(documento: any, index: number) {
    this.loadingDeletarDocumento = index

    const response = await this.getFinanceiroStore.deletarDocumentoAdicional({
      prestadorRecebimentoId: this.prestadorRecebimento.id,
      documentoId: documento.id,
    })

    if (response.success) {
      await this.getFinanceiroStore.geRecebimentoById(this.prestadorRecebimento.id)
      EventBus.$emit('setSnackbar', { show: true, text: 'Documento adicional deletado com sucesso.', icon: 'done', color: '#2E7D32' })
    } else {
      EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema ao deletar o documento adicional.', icon: 'warning', color: '#C62828' })
    }

    this.loadingDeletarDocumento = null
  }

  async downloadNF(documento: any) {
    this.loadingDownloadNf = documento.id

    const response = await this.getFinanceiroStore.download({ prestadorRecebimentoId: documento.id })
    const { data } = response
    const blob = typeof data === 'string' && data.startsWith('data:')
      ? await (await fetch(data)).blob()
      : new Blob([data], { type: 'application/pdf' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = documento.nomeArquivoOriginal || 'documento-adicional.pdf'
    document.body.appendChild(link)
    link.click()
    link.remove()
    window.URL.revokeObjectURL(url)

    this.loadingDownloadNf = null
  }
}
